import { createContext, useContext } from "react";

import type { ModalContextValue } from "../model/types";

export const ModalContext = createContext<ModalContextValue | null>(null);

export const useModalContext = () => {
    const context = useContext(ModalContext);

    if (!context) {
        throw new Error("useModalContext must be used within a ModalProvider");
    }

    return context;
};
